var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.8C13.9554 5.8 15 4.72548 15 3.4C15 2.07452 13.9554 1 12.6667 1C11.378 1 10.3334 2.07452 10.3334 3.4C10.3334 4.72548 11.378 5.8 12.6667 5.8Z",
    stroke: "#389CFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 11.4C4.622 11.4 5.66667 10.3255 5.66667 8.99998C5.66667 7.67449 4.622 6.59998 3.33333 6.59998C2.04467 6.59998 1 7.67449 1 8.99998C1 10.3255 2.04467 11.4 3.33333 11.4Z",
    stroke: "#389CFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 17C13.9554 17 15 15.9255 15 14.6C15 13.2745 13.9554 12.2 12.6667 12.2C11.378 12.2 10.3334 13.2745 10.3334 14.6C10.3334 15.9255 11.378 17 12.6667 17Z",
    stroke: "#389CFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34766 10.2078L10.6599 13.3918",
    stroke: "#389CFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6521 4.60779L5.34766 7.79179",
    stroke: "#389CFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.82acc6d5c393898684481fc8601ad3e8.svg";
export { ForwardRef as ReactComponent };